const getRoles = (user, roleArray, prefix, USE_OKTA) => {
    if (USE_OKTA) {
        if (user && user[roleArray]) {
            const roles = user[roleArray]
            if (Array.isArray(roles)) {
                var roleArrayParts = roles.map(r => r.split(prefix)[1] || r)
                return roleArrayParts.join(',')
            } else {
                return roles
            }
        }
    } else {
        if (user && user.profile && user.profile.role) {
            const roles = user.profile.role
            if (Array.isArray(roles)) {
                return roles.join(',')
            } else {
                return roles
            }
        } else {
            return ''
        }
    }
}

const checkRole = (role, roles) => {
    if (roles && role) {
        return roles.toLowerCase().includes(role.toLowerCase())
    } else {
        return false
    }
}

const hasAccessToAdmin = roles => checkRole('Admin', roles)
const hasAccessToDashboard = roles => checkRole('Dashboard', roles)

export {
    getRoles,
    checkRole,
    hasAccessToAdmin,
    hasAccessToDashboard
}